import PropTypes from "prop-types";
import classNames from "classnames";

import Container from "@/src/components/grid/container";
import ProjectDetailContanctForm from "src/components/project-detail/sticky-contact-form";
import SaleCompleted from "src/components/project-detail/sale-completed";
import ContactAction from "src/components/project-detail/contact-action";

import styles from "./styles.module.css";

const StickyComponent = ({
  projectDetailFormData,
  salesStatus,
  projectCity,
  tradeType,
  category,
  hasRelatedProjects,
  phoneNumber,
  showPhone,
}) => {
  const isSaleCompleted = salesStatus === "FINISHED";

  const formWrapperClass = classNames({
    [styles.saleCompleted]: isSaleCompleted,
    [styles.contactForm]: !isSaleCompleted,
    [styles.noHasRelatedProjects]: !hasRelatedProjects,
    [styles.hasPhoneNumber]: !isSaleCompleted && showPhone,
    [styles.hasPhoneNumberNoRelatedProjects]: !isSaleCompleted && showPhone && !hasRelatedProjects,
  });

  return (
    <Container>
      <div className={styles.contactFormContainer}>
        <div className={styles.emptySpace}></div>
        <div className={formWrapperClass}>
          {isSaleCompleted ? (
            <SaleCompleted projectCity={projectCity} tradeType={tradeType} category={category} />
          ) : (
            <>
              <div className={styles.contactFormWrapper}>
                <ProjectDetailContanctForm projectDetailFormData={projectDetailFormData} isProjectDetailSticky={true} />
              </div>
              {showPhone && (
                <>
                  <span className={styles.separator}>Veya</span>
                  <ContactAction phoneNumber={phoneNumber} />
                </>
              )}
            </>
          )}
        </div>
      </div>
    </Container>
  );
};

StickyComponent.propTypes = {
  projectDetailFormData: PropTypes.object,
  salesStatus: PropTypes.string,
  projectCity: PropTypes.string,
  tradeType: PropTypes.object,
  category: PropTypes.object,
  hasRelatedProjects: PropTypes.bool,
  phoneNumber: PropTypes.string,
  showPhone: PropTypes.bool,
};

export default StickyComponent;
